import MxAutoCompleteField from "@rf-l1/form/selects/MxAutoCompleteField/MxAutoCompleteField";
import { MxAutoCompleteFieldProps } from "@rf-l1/form/selects/MxAutoCompleteField/model/MxAutoCompleteField";
import { useMxFieldControllerContext } from "@/src-refactor/modules/shared/components/refactor/context/MxFieldController";
import { A_ARRANGEMENTS_TYPE } from "@/src-refactor/modules/shared/model/const/property/arrangement-type.const";

type omit = "value" | "id" | "name" | "testId" | "items" | "onChange";
type MxFormSelectArrangementsTypeFieldProps = Omit<MxAutoCompleteFieldProps, omit>
const MxFormSelectArrangementsTypeField = (
  props: MxFormSelectArrangementsTypeFieldProps
) => {
  const { onChange, onBlur, name, value, invalid, id, testId } =
    useMxFieldControllerContext();
  const { ...rest } = props;

  return (
    <MxAutoCompleteField
      {...rest}
      items={A_ARRANGEMENTS_TYPE}
      id={id}
      testId={testId}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
      value={value}
      error={invalid}
    />
  );
};

export default MxFormSelectArrangementsTypeField;
